module.exports = __webpack_public_path__ + "img/arrow.4295eebd.svg";